export default __webpack_public_path__ + "static/huiliang-f57191d7c5c2a1f91c5d831be4466307.png";